import enterVirtualDataFormSettings from './enter-virtual-data-form-settings.json';

class EnterVirtualDataFormService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    $onInit() {
        this.unsavedData = null;
    }

    getFormSettings() {
        return enterVirtualDataFormSettings.includedSettings;
    }


    /***
     *  Automatically save the backed up this.unsavedData object (will maintain the committed/not-committed flag from
     *  the most recently saved entry).
     */
    autoSaveStats() {
        if (this.unsavedData) {
            this.saveStats(this.unsavedData);
        }
    }

    /***
     *  Periodically called to save a backup of the most recently entered stats data. The backup is then used by
     *  the autoSaveStats() function.
     *
     * @param data  a dictionary of saved stats data from the EnterVirtualDataFormController.
     */
    updateUnsavedData(data) {
        this.unsavedData = data;
    }

    /***
     * Saves stats data. If the save is successful, deactivates the previous stats data.
     *
     * @param savedData         an object representing a new Stats row that will be added to
     *                          the database.
     *
     * @returns {Promise}
     */
    saveStats(savedData) {
        return this.$http.post(`${this.appConfig.apiUrl}/stats/virtual/`, savedData);
    }


}

export default EnterVirtualDataFormService;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data-form/enter-virtual-data-form-service.js